import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center mb-x4" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "flex flex-row justify-center gap-x3" }
const _hoisted_4 = { class: "c-magic-line c-magic-line--underline" }
const _hoisted_5 = { class: "mb-x4 text-center" }
const _hoisted_6 = { class: "o-scrollbar-y h-full list-reset w-full pr-20" }
const _hoisted_7 = {
  key: 0,
  class: "break-words text-left w-2/5 lg:w-1/2"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "w-1/5 lg:w-1/4 flex justify-end" }
const _hoisted_11 = {
  key: 0,
  class: "py-2 px-8 bg-brandy block"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "c-magic-line c-magic-line--underline" }

import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import useProductClickAndCollect from '@/shared/product/purchase/ui/useProductClickAndCollect';
import { ProductClickAndCollectStoreInventoryResult } from '@/types/productServerApi';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { computed, ref, Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPurchaseClickAndCollectStoreSelector',
  props: {
    basketHasClickAndCollect: { type: Boolean }
  },
  emits: ['onStoreSelection'],
  setup(__props: any, { emit: emits }) {

const props = __props as { basketHasClickAndCollect: boolean }


const { closeStoreSelector, showStoreSelector, storeInventoryData, storeId, setStoreId, addToBasketOnStoreSelection } = useProductClickAndCollect();

const labels = useBlockLabels();



const showChangeStoreInfo: Ref<boolean> = ref(false);

const potentialNewStoreId: Ref<null | string> = ref(null);

const isCurrentStore = (store: ProductClickAndCollectStoreInventoryResult): boolean => {
    return storeId.value === store.storeId;
};

const storeIsSelectable = (store: ProductClickAndCollectStoreInventoryResult): string => {
    return store.status.namedParams.storeInventoryCount || store.status.label === 'clickAndCollectCanBeDeliveredForPickupInStoreLabel';
};

const title = computed(() => storeId.value ? labels.clickAndCollectChangeStoreTitle : labels.clickAndCollectSelectStoreTitle);

const storeButtonLabel = (store: ProductClickAndCollectStoreInventoryResult): string => {
    const isChangingStore = !isCurrentStore && storeId.value && store.status.namedParams.storeInventoryCount;
    const isSelectingStore = !storeId.value && store.status.namedParams.storeInventoryCount;
    const isSelectingAndAddingToBasket = isSelectingStore && addToBasketOnStoreSelection;
    if (isCurrentStore(store)) {
        return labels.clickAndCollectSelectedStore;
    } else if (isChangingStore) {
        return labels.clickAndCollectChangeStore;
    } else if (isSelectingStore) {
        return labels.clickAndCollectSelectStore;
    } else if (isSelectingAndAddingToBasket) {
        return labels.clickAndCollectSelectStoreAndAddToBasket;
    }
    return labels.clickAndCollectSelectStore;
};

const selectStore = (newStoreId): void => {
    const basketHasDifferentClickAndCollectStore = newStoreId !== storeId.value && props.basketHasClickAndCollect;
    if (basketHasDifferentClickAndCollectStore) {
        showChangeStoreInfo.value = true;
        potentialNewStoreId.value = newStoreId;
    } else {
        setNewStore(newStoreId);
    }
};

const setNewStore = (newStoreId): void => {
    setStoreId(newStoreId);
    emits('onStoreSelection', { storeId: newStoreId });
    potentialNewStoreId.value = null;
    closeStoreSelector();
};

const toggleShowChangeStoreInfo = () => {
    showChangeStoreInfo.value = !showChangeStoreInfo.value;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseDialog, {
    "is-open": _unref(showStoreSelector),
    class: "p-24 mx-auto bg-white overflow-y-scroll flex flex-col fixed inset-0 sm:relative sm:inset-auto z-1 w-screen md:h-auto md:w-screen-80 md:max-h-screen-70 md:max-w-850",
    onClose: _unref(closeStoreSelector)
  }, {
    default: _withCtx(() => [
      _createVNode(_Transition, {
        name: "o-anim-fade-300",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("div", {
            key: `${showChangeStoreInfo.value}`
          }, [
            (showChangeStoreInfo.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(labels).clickAndCollectChangeStore), 1),
                  _createElementVNode("p", {
                    class: "text-center mb-x3",
                    innerHTML: _unref(labels).clickAndCollectChangingStoreInformation
                  }, null, 8, _hoisted_2),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                      class: "c-link",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleShowChangeStoreInfo()))
                    }, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(labels).clickAndCollectChangeStoreGoBack), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "c-button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (setNewStore(potentialNewStoreId.value)))
                    }, _toDisplayString(_unref(labels).clickAndCollectChangeStore), 1)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(title)), 1),
                  _createElementVNode("ul", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(storeInventoryData), (store) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: store.storeId,
                        class: "flex flex-row items-baseline mb-x2 gap-x1 last:mb-0 w-full"
                      }, [
                        (store.storeTitle)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(store.storeTitle), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", {
                          class: _normalizeClass(["w-2/5 flex-no-shrink px-4 lg:w-1/4 lg:px-0", {'text-silver': !storeIsSelectable(store)}])
                        }, [
                          (store.status.namedParams?.storeInventoryCount)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels)[store.status.label], { quantity: store.status.namedParams.storeInventoryCount })), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(labels)[store.status.label]), 1))
                        ], 2),
                        _createElementVNode("span", _hoisted_10, [
                          (isCurrentStore(store))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(storeButtonLabel(store)), 1))
                            : (storeIsSelectable(store))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "c-link",
                                  onClick: ($event: any) => (selectStore(store.storeId))
                                }, [
                                  _createElementVNode("span", _hoisted_13, _toDisplayString(storeButtonLabel(store)), 1)
                                ], 8, _hoisted_12))
                              : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ], 64))
          ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open", "onClose"]))
}
}

})